import React from 'react'
import styled from 'styled-components'

const PreviewLetter = styled.div`
  background: white;
  border-radius: 2px;
  padding: 1rem;
  max-width: 800px;
  border: 1px solid ${props => props.theme.colors.tertiary};
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: flex-start;
  z-index: 99;
  position: relative;
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    padding: 2rem;
  }
  textarea {
    appearance: none;
    font-family: inherit;
    font-size: inherit;
    outline: none;
    background: white;
    border: 1px solid ${props => props.theme.colors.tertiary};
    color: ${props => props.theme.colors.base};
    border-radius: 2px;
    padding: 1em;
  }
`

const Text = styled.div`
  font-size: 1em;
  line-height: 1.2;
  margin: 0 auto;
  p {
    margin: 0 0 1rem 0;
    &:last-child {
      margin: 0;
    }
  }
  strong {
    font-weight: 600;
  }
  em {
    font-style: italic;
  }
  ul {
    display: block;
    list-style-type: disc;
    -webkit-margin-before: 1em;
    -webkit-margin-after: 1em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
    -webkit-padding-start: 40px;
  }
`

const RepsResults = ({ error, mla, mp, isLoading }) => {
  if (error) {
    return null
  }

  if (isLoading) {
    return <p>Getting representatives...</p>
  }

  if (!mla && !mp) {
    return <p>CC: Your provincial and federal representatives</p>
  }

  if (mla && mp) {
    return <p>CC: {mla.name}, {mp.name}</p>
  } else if (mla) {
    return <p>CC: {mla.name}</p>
  } else if (mp) {
    return <p>CC: {mp.name}</p>
  }
}

const Signature = ({ details }) => {
  if (!details.firstName && !details.lastName) {
    return <span>Concerned Citizen</span>
  } else {
    return <span>{details.firstName} {details.lastName}<br/>{details.skilledTrade || details.businessName}</span>
  }
}

const Location = ({ city }) => {
  if (!city) {
    return <span>British Columbia</span>
  } else {
    return <span>{city}, British Columbia</span>
  }
}

class Preview extends React.Component {
  render() {
    if (this.props.type === 'worker') {
      return (
        <PreviewLetter>
          <Text>
            <p>Dear Premier Horgan,</p>
            <p>RE: I VOTE NO TO THE CBA</p>
            <p>I’m a skilled tradesperson, a taxpayer, a proud British Columbian, and a Canadian citizen.</p>
            <p>I work hard at my trade and participate as a productive member of my community and the economy. 
              I take pride in what I build and in the role the construction industry plays in our province. 
              I have the skills and training I need to build whatever the public and private sectors decide to build, 
              and to do it safely to world class standards.</p>
            <p>These are my choices, opportunities, and achievements.</p>
            <p><strong>It is not acceptable for you to force me to join a union and accept a government Crown Corporation 
              as my employer.</strong></p>
            <p>Today’s construction employers offer competitive salaries, benefits, and training, and they prioritize a safe worksite.  Unions have a role, and are right for some, but not all.</p>
            <p>If I wanted to join a designated union, I would have done that already.</p>
            <p>If the Community Benefits Agreement announced by your government on July 16, 2018 moves forward, my industry will do everything in its power to reverse it.  I will seek work on non-government projects, and will encourage my employer to do the same.</p>
            <p>The Canadian Charter of Rights and Freedoms guarantees my freedoms of equality, expression, and assembly. Please, allow me to choose my employer, and allow us to compete for public sector projects based on our skills and experience. </p>
            <p>Send this CBA back to the archives and deliver the political balance and opportunity for all British Columbians that you promised during your campaign.</p>
            <p>Sincerely,</p>
            <p><Signature details={this.props.data} /><br/>
            <Location city={this.props.data.city} /></p>
            <RepsResults mla={this.props.data.mla} mp={this.props.data.mp} />
            <p><em>This campaign is sponsored by: BC Construction Association, CCA, NRCA, SICA, VICA, and VRCA.</em></p>
          </Text>
        </PreviewLetter>
      )
    } else {
      return (
        <PreviewLetter>
          <Text>
            <p>Dear Premier Horgan,</p>
            <p>RE: COMMUNITY BENEFITS AGREEMENT (CBA)</p>
            <p>The new CBA is the latest and most destructive item in a growing catalog of urgent issues concerning BC’s industrial, commercial and institutional (ICI) construction employers.</p>
            <p>I am one of those employers. The CBA is a disincentive for my company to bid on government projects. Here’s why:</p>
            <ul>
              <li>It is a contravention of the Canadian Charter of Rights for government to force my employees to join a union and accept a Crown Corporation as their employer;</li>
              <li>Claims that this CBA will create more stable construction sites, improve apprenticeship and safety outcomes, and increase opportunities for women and indigenous workers are unfounded and easily disproven;</li>
              <li>The estimate of a 4-7% cost increase as a result of this new scheme is a gross miscalculation - the impact to tax payers will be much greater.</li>
              <li>The CBA contravenes government’s responsibility to fair, open, and transparent procurement.</li>
            </ul>
            <p>Unions have a role to play, and are right for some, but not all. Although your government claims to prioritize community engagement and public discourse, this major decision came without either: 80% of our industry was not represented during the creation of this policy.</p>
            <p>The result is not a Community Benefit Agreement but a labour agreement which undermines the role of employers – both union and open-shop – in order to artificially bolster the power of a select few.</p>
            <p>In the fall our MPs will vote on Bill C-344 (An Act to amend the Department of Public Works and Government Services Act (Community Benefits)) which is defended by similar false assumptions:   that construction employers do not proactively support communities, apprenticeship, training, safety, or equity seeking groups.  I urge my MP, cc’d here, to vote against Bill C-344.</p>
            <p>If the CBA announced by BC’s NDP government on July 16, 2018 moves forward, my industry will do everything in its power to reverse it.</p>
            <p>This is not the kind of innovation that BC needs to compete and succeed in Canada or the world. Please, move forward instead with initiatives that are productive for the long term success of our industry and our provincial economy.</p>
            <p>Sincerely,</p>
            <p><Signature details={this.props.data} /><br/>
            <Location city={this.props.data.city} /></p>
            <RepsResults mla={this.props.data.mla} mp={this.props.data.mp} />
            <p><em>This campaign is sponsored by: BC Construction Association, CCA, NRCA, SICA, VICA, and VRCA.</em></p>
          </Text>
        </PreviewLetter>
      )
    }
  }
}

export default Preview



// WEBPACK FOOTER //
// ./src/components/Preview.js